<template>
  <div class="has-text-centered">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <p style="max-width: 800px; margin: auto;">
      {{ $t("users.blockUserExplanation") }}
    </p>
    <br />

    <div class="columns" v-if="permissions.blockClient">
      <div class="column is-one-quarter">
        <b-input
          v-model="email"
          :placeholder="$t('users.userEmailPlaceholder')"
        ></b-input>
      </div>

      <div class="column">
        <b-input v-model="reason" :placeholder="$t('users.reason')"></b-input>
      </div>

      <div class="column is-narrow">
        <b-button
          :style="{
            backgroundColor: $primaryColor,
            color: $primaryColorContrast
          }"
          @click="blockUser"
        >
          {{ $t("users.block") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      email: "",
      reason: ""
    };
  },

  methods: {
    blockUser() {
      this.isLoading = true;
      this.$store
        .dispatch("blockUser", {
          email: this.email,
          reason: this.reason
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("get-blocked-users");
            this.email = "";
            this.reason = "";
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>
